/* src/app/settlement/add-edit-settlement/add-edit-settlement.component.css */
/*# sourceMappingURL=add-edit-settlement.component-Q63ZSWHK.css.map */
